module.exports = __webpack_public_path__ + "img/amex.89a62e9b.png";